
function CalendarIcon(): JSX.Element {
  return (
    <div>
      <svg
        width="23"
        height="23"
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.08301"
          y="4"
          width="16.8333"
          height="15"
          rx="1.25"
          stroke="#707CB2"
          strokeWidth="1.5"
        />
        <line
          x1="2.99219"
          y1="9.20654"
          x2="19.5066"
          y2="9.20654"
          stroke="#707CB2"
          strokeWidth="1.5"
        />
        <rect
          x="5.42188"
          y="11.5"
          width="3.66667"
          height="2.29167"
          rx="1.14583"
          fill="#707CB2"
        />
        <line
          x1="7.46875"
          y1="2.44897"
          x2="7.46875"
          y2="4.96779"
          stroke="#707CB2"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="15.7187"
          y1="2.44897"
          x2="15.7188"
          y2="4.96779"
          stroke="#707CB2"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default CalendarIcon;
